var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoWrap"},[_c('video',{attrs:{"id":"fxTcplayer","preload":"auto","playsinline":"","webkit-playsinline":""}}),_c('div',{class:['poster', _vm.isShowPoster ? 'realShow' : 'realHide']},[_c('img',{attrs:{"src":_vm.posterSrc,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }